import React, { useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { BsImage } from "react-icons/bs";
import { Bars } from "react-loader-spinner";
import { toast } from "react-toastify";
import DeleteModal from "../../components/Common/DeleteModal/DeleteModal";
import {
  useAddCategoryMutation,
  useCategoriesQuery,
  useDeleteCategoryMutation,
  useUpdateCategoryMutation,
} from "../../service/categoryApi";
import { uploadImage } from "../../helpers/uploadImage";

const Categories = () => {
  const [addCategory] = useAddCategoryMutation();
  const [updateCategory] = useUpdateCategoryMutation();
  const [deleteCategory] = useDeleteCategoryMutation();
  const [deleteModal, setDeleteModal] = useState(false);
  const { data } = useCategoriesQuery();
  const [name, setName] = useState("");
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState({});
  const [updateName, setUpdateName] = useState("");
  const [subCategory, setsubCategory] = useState(false);
  const [subCategories, setSubCategories] = useState([]);
  const [description, setDescription] = useState("");
  const [currentCat, setCurrentCat] = useState("");
  const [banners, setBanners] = useState("");
  const [loading, setLoading] = useState(false);
  const [updateSubCategories, setUpdateSubCategories] = useState([]);
  const [updateCurrentCat, setUpdateCurrentCat] = useState('');
  const [updateBanners, setUpdateBanners] = useState("");
  const [updateBannerLoading, setUpdateBannerLoading] = useState(false);
  console.log(selected);
  const handleAddCategory = () => {
    const data = {
      name: name,
      value: name?.toLowerCase(),
      subCategory: subCategory,
      subCategories: subCategories,
      banners: banners,
      description,
    };
    if (name && description && banners) {
      addCategory(data).then((res) => {
        if (res?.data?.status) {
          toast.success(res?.data?.message);
          setName("");
          setsubCategory(false);
          setBanners("");
          setSubCategories([]);
        } else {
          toast.error(res?.data?.message);
        }
      });
    } else {
      toast.error("Please fill the required field!");
    }
  };

  const handleCheckboxChange = (e) => {
    setsubCategory(e.target.checked);
    setSubCategories([]);
  };

  const handleUpdateBannerUpload = async (e) => {
    if (!e.target.files[0]) return;
    setUpdateBannerLoading(true);
    try {
      const url = await uploadImage(e.target.files[0]);
      setUpdateBanners(url);
    } catch (err) {
      console.error(err);
      toast.error(`Failed to upload banner: ${err.message}`);
    } finally {
      setUpdateBannerLoading(false);
    }
  };

  const handleUpdateCategory = () => {
    const data = {
      name: updateName,
      value: updateName?.toLowerCase(),
      subCategory: updateSubCategories.length > 0 ? true : false,
      subCategories: updateSubCategories,
      description: description,
      banners: updateBanners,
    };
    if (updateName) {
      updateCategory({ id: selected?._id, data: data }).then((res) => {
        if (res?.data?.status) {
          toast.success(res?.data?.message);
          setName("");
          setsubCategory(false);
          setShow(false);
          setDeleteModal(false);
          setSelected({});
        } else {
          toast.error(res?.data?.message);
        }
      });
    } else {
      toast.error("Please fill the required field!");
    }
  };

  const handleDeleteCategory = () => {
    if (selected?._id) {
      deleteCategory(selected?._id).then((res) => {
        if (res?.data?.status) {
          toast.success(res?.data?.message);
          setName("");
          setsubCategory(false);
          setShow(false);
          setDeleteModal(false);
          setSelected({});
        } else {
          toast.error(res?.data?.message);
        }
      });
    } else {
      toast.error("Please Select at least one element!");
    }
  };

  const handleImageUpload = async (e) => {
    setLoading(true);

    if (!e.target.files[0]) {
      setLoading(false);
      return;
    }

    try {
      // Upload via our API, which stores the file in Google Cloud Storage.
      const url = await uploadImage(e.target.files[0]);
      setBanners(url);
      console.log("File uploaded successfully:", url);
    } catch (err) {
      console.error(err);
      toast.error(`Failed to upload banner: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };
  const handleRemove = () => {
    setBanners("");
  };

  const handleAddSubCategory = () => {
    setSubCategories([...subCategories, currentCat]);
    setCurrentCat("");
  };

  const handleRemoveCat = (cat) => {
    const filter = subCategories.filter((i) => i !== cat);
    setSubCategories(filter);
  };
  const handleUpdateSubCategory = (cat) => {
    const filter = updateSubCategories?.filter((i) => i !== cat);
    setUpdateSubCategories(filter);
  };

  const handleAddUpdateSubCategory = () => {
    setUpdateSubCategories([...updateSubCategories, updateCurrentCat]);
    setUpdateCurrentCat("");
  };
  return (
    <div className="container mx-auto">
      <div className="bg-gray-700 my-[30px] rounded p-[10px]">
        <h3 className="text-start text-[20px] font-bold text-white mb-[20px]">
          Add Category
        </h3>
        <div className="mb-[15px] flex flex-col">
          <label className="text-white mb-[10px]">Category</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] md:w-[50%] lg:w-[33%] rounded"
          />
          <label className="inline-flex items-center mt-3 text-white">
            <input
              type="checkbox"
              onChange={handleCheckboxChange}
              checked={subCategory}
              className="form-checkbox h-5 w-5 text-green-600"
            />
            <span className="ml-2 text-white text-[16px]">Sub category?</span>
          </label>
        </div>
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded focus:border-0 h-[200px]"
            cols={12}
          />
        </div>

        {subCategory && (
          <div className="mb-[15px] flex flex-col">
            <label className="text-white mb-[10px]">Sub Category</label>
            <div>
              <input
                value={currentCat}
                onChange={(e) => setCurrentCat(e.target.value)}
                className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] md:w-[50%] lg:w-[33%] rounded"
              />
              <button
                onClick={handleAddSubCategory}
                className="bg-green-700 outline-none font-[17px] text-white p-[10px]"
              >
                Add subCategory
              </button>
            </div>
            <div className=" text-white mt-[20px]">
              <p className="font-bold text-[20px]">Added Sub Categories</p>
              <ul className="text-white list-disc ml-[20px]">
                {subCategories?.map((s) => (
                  <li>
                    {s}{" "}
                    <span
                      onClick={() => handleRemoveCat(s)}
                      className="ml-[5px] font-bold text-[red] cursor-pointer"
                    >
                      X
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}

        <div className="grid gap-4 mb-3">
          <div className="mb-3 flex flex-col">
            <label className="text-white mb-[10px]">Banners Images</label>
            <div>
              <label
                className="text-[1.5rem] flex items-center gap-[.5rem] justify-center w-[100%] h-[100px] bg-gray-900 cursor-pointer text-white"
                htmlFor="banner"
              >
                {loading ? (
                  <Bars
                    height="80"
                    width="80"
                    color="#fff"
                    ariaLabel="bars-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                  />
                ) : (
                  <>
                    <BsImage /> Upload Image
                    <input
                      onChange={handleImageUpload}
                      className="hidden"
                      type="file"
                      name="banner"
                      id="banner"
                    />
                  </>
                )}
              </label>
            </div>
            {banners && (
              <>
                <p className="text-white font-semibold text-[13px] mt-[15px]">
                  Uploaded Banner
                </p>
                <div className="flex flex-wrap justify-start items-center gap-[10px]">
                  {banners && (
                    <div className="relative">
                      <img
                        className="h-[280px] w-[500px]"
                        key={banners}
                        src={banners}
                        alt="images"
                      />
                      <AiFillCloseCircle
                        style={{ color: "white" }}
                        className="h-[28px] w-[28px] absolute top-[10px] right-[10px]"
                        onClick={() => handleRemove(banners)}
                      />
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        <button
          onClick={handleAddCategory}
          className="bg-[#47db47] px-[20px] py-[7px] rounded text-[white] hover:bg-[#399439] active:bg-[#9b3232]"
        >
          Add Category
        </button>
      </div>

      {/* table */}
      <div className="bg-gray-700 my-[30px] rounded p-[10px]">
        <h3 className="text-start text-[20px] font-bold text-white mb-[20px]">
          Category List
        </h3>

        <div class="relative overflow-x-auto shadow-md bg-gray-900 sm:rounded-lg">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead>
              <tr className="shadow shadow-gray-700">
                <th scope="col" class="px-6 py-3">
                  Category
                </th>
                <th scope="col" class="px-6 py-3">
                  Value
                </th>
                <th scope="col" class="px-6 py-3">
                  Update
                </th>
                <th scope="col" class="px-6 py-3">
                  Delete
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.data?.map((d) => (
                <tr className="shadow shadow-gray-700">
                  <td class="px-6 py-4">{d?.name}</td>
                  <td class="px-6 py-4">{d?.value}</td>
                  <td class="px-6 py-4">
                    <button
                      onClick={() => {
                        setShow(true);
                        setUpdateSubCategories(d?.subCategories);
                        setSelected(d);
                        setUpdateName(d?.name);
                        setUpdateBanners(d?.banners || "");
                      }}
                      className="bg-[#47db47] px-[20px] py-[7px] rounded text-[white] hover:bg-[#399439] active:bg-[#9b3232]"
                    >
                      Update
                    </button>
                  </td>
                  <td class="px-6 py-4">
                    <button
                      onClick={() => {
                        setSelected(d);
                        setDeleteModal(true);
                      }}
                      className="bg-[#ce3737] px-[20px] py-[7px] rounded text-[white] hover:bg-[#ff3939] active:bg-[#9b3232]"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* modal */}

      {show && (
        <div class="fixed top-0 left-0 right-0 bottom-0 z-50 pt-[200px] w-full flex justify-center p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
          <div class="relative w-full max-w-md max-h-full">
            <div class="relative rounded-lg shadow bg-gray-600">
              <button
                onClick={() => setShow(false)}
                type="button"
                class="absolute top-3 right-2.5 text-gray-300 bg-transparent rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center hover:text-white"
                data-modal-hide="authentication-modal"
              >
                <svg
                  class="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span class="sr-only">Close modal</span>
              </button>
              <div class="px-6 py-6 lg:px-8">
                <h3 className="text-center text-[20px] font-bold text-white mb-[20px]">
                  Update Category
                </h3>
                <div className="mb-3 flex flex-col">
                  <label className="text-white mb-[10px]">Category</label>
                  <input
                    value={updateName}
                    onChange={(e) => setUpdateName(e.target.value)}
                    className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] rounded"
                  />
                  <div className="mt-[20px] ">
                    <input
                      value={updateCurrentCat}
                      onChange={(e) => setUpdateCurrentCat(e.target.value)}
                      className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] md:w-[50%] lg:w-[33%] rounded"
                    />
                    <button
                      onClick={handleAddUpdateSubCategory}
                      className="bg-green-700 outline-none font-[17px] text-white p-[10px]"
                    >
                      Add subCategory
                    </button>
                  </div>
                  <div className=" text-white mt-[20px]">
                    <p className="font-bold text-[20px]">
                      Added Sub Categories
                    </p>
                    <ul className="text-white list-disc ml-[20px]">
                      {updateSubCategories?.map((s) => (
                        <li>
                          {s}{" "}
                          <span
                            onClick={() => handleUpdateSubCategory(s)}
                            className="ml-[5px] font-bold text-[red] cursor-pointer"
                          >
                            X
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Banner edit */}
                <div className="mb-3 flex flex-col">
                  <label className="text-white mb-[10px]">Banner</label>
                  <label
                    htmlFor="update-cat-banner"
                    className="text-[1.2rem] flex items-center gap-[.5rem] justify-center w-[100%] h-[80px] bg-gray-900 cursor-pointer text-white rounded"
                  >
                    {updateBannerLoading ? (
                      <Bars height="28" width="28" color="#ffffff" visible={true} />
                    ) : (
                      <>
                        <BsImage /> {updateBanners ? "Replace Banner" : "Upload Banner"}
                      </>
                    )}
                    <input
                      onChange={handleUpdateBannerUpload}
                      className="hidden"
                      type="file"
                      id="update-cat-banner"
                      accept="image/*,.heic"
                    />
                  </label>
                  {updateBanners && (
                    <div className="relative mt-[10px] w-[200px]">
                      <img
                        src={updateBanners}
                        alt="banner"
                        className="w-[200px] rounded"
                      />
                      <AiFillCloseCircle
                        style={{ color: "white" }}
                        className="h-[28px] w-[28px] absolute top-[8px] right-[8px] cursor-pointer"
                        onClick={() => setUpdateBanners("")}
                      />
                    </div>
                  )}
                </div>

                <button
                  onClick={handleUpdateCategory}
                  className="bg-[#47db47] w-[100%] px-[20px] py-[7px] rounded text-[white] hover:bg-[#399439] active:bg-[#9b3232]"
                >
                  Update Category
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {deleteModal && (
        <DeleteModal
          handleDelete={handleDeleteCategory}
          closeModal={setDeleteModal}
        />
      )}
    </div>
  );
};

export default Categories;
